import { Link, useLocation } from 'react-router-dom';
import { X, Home, Calendar, Target, CreditCard, LineChart, Bell, User, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

interface NavItem {
  name: string;
  path: string;
  icon: React.ReactNode;
  roles?: string[];
}

interface SidebarProps {
  onClose?: () => void;
}

const navigation: NavItem[] = [
  { 
    name: 'Dashboard', 
    path: '/dashboard', 
    icon: <Home className="h-5 w-5" />,
    roles: ['admin', 'coach', 'swimmer', 'parent']
  },
  { 
    name: 'Calendar', 
    path: '/calendar', 
    icon: <Calendar className="h-5 w-5" />,
    roles: ['admin', 'coach', 'swimmer', 'parent']
  },
  { 
    name: 'Teams', 
    path: '/teams', 
    icon: <Users className="h-5 w-5" />,
    roles: ['admin', 'coach']
  },
  { 
    name: 'Events', 
    path: '/dashboard/events', 
    icon: <Target className="h-5 w-5" />,
    roles: ['admin', 'coach']
  },
  { 
    name: 'Payments', 
    path: '/dashboard/payments', 
    icon: <CreditCard className="h-5 w-5" />,
    roles: ['admin', 'coach', 'parent']
  },
  { 
    name: 'Performance', 
    path: '/dashboard/performance', 
    icon: <LineChart className="h-5 w-5" />,
    roles: ['admin', 'coach', 'swimmer']
  },
  { 
    name: 'Reminders', 
    path: '/dashboard/reminders', 
    icon: <Bell className="h-5 w-5" />,
    roles: ['admin', 'coach', 'swimmer', 'parent']
  },
  { 
    name: 'Profile', 
    path: '/dashboard/profile', 
    icon: <User className="h-5 w-5" />,
    roles: ['admin', 'coach', 'swimmer', 'parent']
  },
];

const Sidebar: React.FC<SidebarProps> = ({ onClose }) => {
  const location = useLocation();
  const { getUserRole } = useAuth();
  const userRole = getUserRole();

  const filteredNavigation = navigation.filter(
    item => !item.roles || item.roles.includes(userRole)
  );

  return (
    <aside className="bg-gray-800 text-white w-64 min-h-screen p-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">Menu</h2>
        <Button
          variant="ghost"
          className="md:hidden text-white hover:text-gray-300"
          onClick={onClose}
        >
          <X className="h-6 w-6" />
        </Button>
      </div>
      <nav className="space-y-2">
        {filteredNavigation.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={onClose}
            className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
              location.pathname === item.path
                ? 'bg-gray-900 text-white'
                : 'text-gray-300 hover:bg-gray-700'
            }`}
          >
            {item.icon}
            <span>{item.name}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar; 